module.exports = __webpack_public_path__ + "static/media/ezreal.a719fecd.png";